import { useEffect, useState } from "react";
import { SlidersHorizontal, Save, Loader2, RefreshCw } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";

const TOGGLES = [
  ["auto_generate_sku", "Auto-generate SKU", "Naya product banate waqt SKU apne aap bane"],
  ["require_sku", "SKU required", "SKU bina product save na ho"],
  ["require_price", "Price required", "Price 0 ho to save na ho"],
  ["require_image", "Image required", "Photo bina product save na ho"],
  ["allow_backorder", "Allow backorder", "Stock 0 hone par bhi order le"],
  ["auto_add_pos", "Auto add to POS", "Naya product POS billing me dikhe"],
  ["auto_publish_online", "Auto publish online", "Naya product website par turant live"],
  ["auto_feature", "Auto feature", "Naya product featured me dikhe"],
  ["show_out_of_stock", "Show out-of-stock", "Stock khatam hone par bhi listing me dikhe"],
];

export default function AdminProductDefaults() {
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/product-defaults").then((r) => setD(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/product-defaults", d); toast.success("Product defaults saved — app par sync hoga"); load(); }
    catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };
  const set = (k, v) => setD((s) => ({ ...s, [k]: v }));

  if (!d) return <div className="p-6 text-slate-400" data-testid="product-defaults-loading">Loading…</div>;

  return (
    <div className="p-4 md:p-6 space-y-5" data-testid="admin-product-defaults-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center"><SlidersHorizontal size={22} /></div>
          <div>
            <h1 className="text-xl md:text-2xl font-extrabold text-slate-900">Product Defaults</h1>
            <p className="text-sm text-slate-500">Naye product ke default rules — app aur website dono par same. 2-way sync.</p>
          </div>
        </div>
        <button onClick={load} data-testid="product-defaults-refresh" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 border border-slate-200 rounded-lg px-3 py-2 hover:bg-slate-50"><RefreshCw size={15} /> Refresh</button>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-4 md:p-5">
        <h2 className="font-bold text-slate-800 mb-3">Default values</h2>
        <div className="grid md:grid-cols-3 gap-3">
          <label className="text-sm"><span className="text-slate-500">Default unit</span><input data-testid="pd-default-unit" value={d.default_unit || ""} onChange={(e) => set("default_unit", e.target.value)} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2" /></label>
          <label className="text-sm"><span className="text-slate-500">Default category</span><input data-testid="pd-default-category" value={d.default_category || ""} onChange={(e) => set("default_category", e.target.value)} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2" /></label>
          <label className="text-sm"><span className="text-slate-500">Default status</span><select data-testid="pd-default-status" value={d.default_status || "active"} onChange={(e) => set("default_status", e.target.value)} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2"><option value="active">active</option><option value="inactive">inactive</option><option value="draft">draft</option></select></label>
          <label className="text-sm"><span className="text-slate-500">Default GST %</span><input data-testid="pd-default-gst" type="number" value={d.default_gst ?? 0} onChange={(e) => set("default_gst", e.target.value)} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2" /></label>
          <label className="text-sm"><span className="text-slate-500">Default min stock</span><input data-testid="pd-default-min-stock" type="number" value={d.default_min_stock ?? 0} onChange={(e) => set("default_min_stock", e.target.value)} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2" /></label>
          <label className="text-sm"><span className="text-slate-500">Default stock</span><input data-testid="pd-default-stock" type="number" value={d.default_stock ?? 0} onChange={(e) => set("default_stock", e.target.value)} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2" /></label>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-4 md:p-5">
        <h2 className="font-bold text-slate-800 mb-3">Rules</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {TOGGLES.map(([k, label, desc]) => (
            <label key={k} data-testid={`pd-${k}`} className={`flex items-start gap-2.5 p-3 rounded-xl border cursor-pointer ${d[k] ? "border-orange-300 bg-orange-50" : "border-slate-200"}`}>
              <input type="checkbox" checked={!!d[k]} onChange={(e) => set(k, e.target.checked)} className="accent-orange-600 w-4 h-4 mt-0.5" />
              <div><p className="text-sm font-semibold text-slate-800">{label}</p><p className="text-xs text-slate-500">{desc}</p></div>
            </label>
          ))}
        </div>
      </div>

      <button onClick={save} disabled={saving} data-testid="product-defaults-save" className="inline-flex items-center gap-2 bg-orange-600 text-white font-bold px-5 py-2.5 rounded-lg hover:bg-orange-700 disabled:opacity-60">{saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Save Defaults</button>
    </div>
  );
}
